import { useEffect } from 'react';

import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '@nesso/ui/primitives/button';
import { SheetBody, SheetFooter } from '@nesso/ui/primitives/sheet';

import { SaveLocationFields, useSaveLocationForm } from '@/features/practice/save-location';

type Props = {
    onCancel: () => void;
    onAdded: () => void;
    onPendingChange: (pending: boolean) => void;
};

export function AddLocationSheetForm({ onCancel, onAdded, onPendingChange }: Props) {
    const saveLocation = useSaveLocationForm({
        onSuccess: (name) => {
            toast.success(`${name} location added`);
            onAdded();
        },
    });

    useEffect(() => {
        onPendingChange(saveLocation.isPending);
        return () => onPendingChange(false);
    }, [saveLocation.isPending, onPendingChange]);

    return (
        <form onSubmit={saveLocation.onSubmit} className="flex min-h-0 flex-1 flex-col">
            <SheetBody className="flex-1 overflow-y-auto">
                <SaveLocationFields form={saveLocation} />
            </SheetBody>
            <SheetFooter>
                <Button
                    type="button"
                    variant="ghost"
                    disabled={saveLocation.isPending}
                    onClick={onCancel}
                >
                    Cancel
                </Button>
                <Button type="submit" disabled={saveLocation.isPending}>
                    {saveLocation.isPending && <Loader2 className="animate-spin" />}
                    Add Location
                </Button>
            </SheetFooter>
        </form>
    );
}
